import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-sales_def",
  "use": "icon-sales_def-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-sales_def\"><path d=\"M819.2 204.8v750.94a136.56 136.56 0 0 0 136.54-136.54V273.08h-68.28V204.8h68.28A68.26 68.26 0 0 1 1024 273.08V819.2a204.88 204.88 0 0 1-170.66 202v2.8H204.8A204.82 204.82 0 0 1 0 819.2V68.26A68.26 68.26 0 0 1 68.26 0h682.66a68.26 68.26 0 0 1 68.28 68.26zM170.66 341.34a34.14 34.14 0 0 0 0 68.26h409.6a34.14 34.14 0 1 0 0-68.26z m0 204.8a34.14 34.14 0 0 0 0 68.26h409.6a34.14 34.14 0 1 0 0-68.26z\" p-id=\"1897\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/sales_def.svg
// module id = Au+r
// module chunks = 39